import*as o from"./_polyfill-node.util.js";import{getAugmentedNamespace as r}from"./_commonjsHelpers.js";var l=r(o);export{l as default};
